import React from 'react'; 
import appIconImg from 'images/icon/app_icon-126x126.png';
import closeImg from 'images/close_icon.png'; 
import { ModalWrapper, Modal, ModalHeader, HeaderLeft, HeaderMid, AppIcon, HeaderRight, CloseIcon, ModalBody, ModalTxt, AppStoreBtn } from './style';
export default function AppStoreRedirectModal ({onClose}){   
    const currLink = window.location.href;
    const appLink = `https://plink.motiners.com/?link=${currLink}&apn=com.motiners.bundle&isi=1556370860&ibi=com.motiners.motinersapp`;

    return (
        <ModalWrapper onClick={(e)=>{if(e.currentTarget === e.target && onClose) onClose();}}>
            <Modal>
                <ModalHeader>   
                    <HeaderLeft></HeaderLeft>
                    <HeaderMid><AppIcon src={appIconImg} /></HeaderMid>
                    <HeaderRight onClick={(e)=>{if(onClose) onClose();}}><CloseIcon src={closeImg} /></HeaderRight>

                </ModalHeader>
                <ModalBody>
                    <ModalTxt>잊기쉬운 루틴,<br />
                    앱으로 알림 받고 빠짐없이 완료하세요!</ModalTxt>
                    <AppStoreBtn target={"_blank"} href={appLink}> 앱으로 보기</AppStoreBtn>
                </ModalBody>
            </Modal>
        </ModalWrapper>);
}
